import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { AccountService } from '../account.service';
import { User } from '../../interfaces/user';
import { FirebaseService } from 'app/services/firebase.service';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-email-log-in',
  templateUrl: './email-log-in.component.html',
  styleUrls: ['../account.scss']
})
export class EmailLogInComponent implements OnInit {
  existingCred;
  user = new User();
  errors: any = {};
  appname = environment.name;
  isLoading;
  redirectUrl;


  constructor(
    public accountService: AccountService,
    public router: Router,
    private firebaseService: FirebaseService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.redirectUrl = this.activatedRoute.snapshot.queryParamMap.get('next');
    this.existingCred = this.activatedRoute.snapshot.queryParamMap.get('cred');
    this.user.username = this.existingCred ? this.existingCred : '';
    this.user.username = this.activatedRoute.snapshot.queryParamMap.get('cred');
  }

  setIsLoading(ev) {
    this.isLoading = ev;
  }

  setError(ev) {
    this.errors = ev;
  }

  public onSubmit() {
    if (this.activatedRoute.snapshot.queryParamMap.get('contrib')) {
      this.accountService.projectId = this.activatedRoute.parent.snapshot.paramMap.get('uuid');
      this.accountService.invitationToken = this.activatedRoute.snapshot.queryParamMap.get('token');
      this.accountService.isDone = this.activatedRoute.snapshot.queryParamMap.get('done') === 'true';
    }
    this.isLoading = false;
    this.accountService.login(this.user, this.redirectUrl).subscribe(
      data => {
        this.firebaseService.setUserId(data.user_id);
        this.firebaseService.logEvent('login', {
          method: 'email',
        });
        this.isLoading = false;
        if (this.activatedRoute.snapshot.queryParamMap.get('contrib')) {
          window.location.href = this.activatedRoute.snapshot.queryParamMap.get('contrib');
        }
      },
      errors => {
        this.errors = errors;
        this.isLoading = false;
        this.firebaseService.logEvent('login_error', {
          reason: errors.detail,
        });
      }
    );
  }
}
